<div class="flex flex-col max-w-240 md:min-w-160 -m-6 rounded-lg" *ngIf="!withError">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 text-on-primary content-tittle">
        <div class="text-lg">Cargar Archivo</div>
        <button
            *ngIf="!loading"
            mat-icon-button
            (click)="dialogRef.close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
    <div class="flex flex-col flex-auto p-4 sm:p-4 flex items-center justify-center" *ngIf="!loading">
        <input type="file" id="file" accept="text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" (change)="handleFileInput($event.target.files)">
    </div>

    <div class="flex flex-col flex-auto p-4 sm:pb-0 p-4 sm:pb-0 overflow-y-auto contenedor-file bold-title" *ngIf="loading">
        Procesando archivo...
    </div>
    <div class="flex flex-row p-6 sm:p-8 pt-2 sm:pt-2 justify-end items-end content-end">
        <button class="flex mr-3 cancel-evk-button" mat-raised-button type="button" (click)="dialogRef.close()" [disabled]="loading">
            Cancelar
        </button>
        <button [disabled]="!fileToUpload || loading" (click)="uploadFileToActivity()"
                class="evk-button"
                [ngClass]="{'disabled-evk-cuu': !fileToUpload || loading}">
            <span *ngIf="!loading">Continuar</span>
            <mat-progress-spinner
                            *ngIf="loading"
                            [diameter]="24"
                            [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
    </div>
</div>
<div class="flex flex-col max-w-240 md:min-w-200 -m-6 rounded-lg w-90" *ngIf="withError">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg">Resultado del Procesamiento</div>
    </div>
    <div class="flex flex-col flex-auto p-4 sm:pb-0 p-4 sm:pb-0 overflow-y-auto contenedor-file bold-title">
        Se encontraron los siguientes errores en el archivo:
    </div>
    <div class="flex flex-col flex-auto p-4 sm:p-4 overflow-y-auto contenedor-file" *ngIf="!errors && !withErrorGeneral">
        Error de comunicación. Favor de intentar más tarde.
    </div>
    <div class="flex flex-col flex-auto p-4 sm:p-4 overflow-y-auto contenedor-file" *ngIf="withErrorGeneral">
        Ocurrió un error al procesar el archivo. Favor de intentar más tarde.
    </div>
    <mat-list class="list-errors-file" role="list" *ngIf="errors && !withErrorGeneral">
        <mat-list-item role="listitem" *ngFor="let error of errors;">
            Error en el renglón {{error.row_number + 2}}
        </mat-list-item>
    </mat-list>

    <div class="flex flex-col flex-auto px-4 sm:px-4 overflow-y-auto contenedor-file success-message" *ngIf="errors && !withErrorGeneral">
        El renglón o renglones que no aparecen en el listado han sido procesados de manera satisfactoria.
    </div>
    <div class="flex flex-row p-6 sm:p-8 pt-0 sm:pt-0 justify-end items-end content-end">
        <button [disabled]="!fileToUpload" (click)="closeModal()" mat-raised-button type="button" class="ml-3 evk-button">
            Aceptar
        </button>
    </div>
</div>



